module.exports = __webpack_public_path__ + "static/media/antena1.fw.a56fa3da.png";